import { PropsWithChildren } from "react";

import ErrorScreen from "~/modules/app/screens/ErrorScreen";
import LoadingScreen from "~/modules/app/screens/LoadingScreen";

import useMeGetUserInfoQuery from "../api/useMeGetUserInfoQuery";
import UserContext from "./UserContext";

export default function UserContextProvider({ children }: PropsWithChildren<unknown>) {
    const { data, loading, error } = useMeGetUserInfoQuery();

    if (loading) {
        return <LoadingScreen />;
    }

    if (error) {
        return <ErrorScreen error={error} />;
    }

    return <UserContext.Provider value={data}>{children}</UserContext.Provider>;
}
